import { render } from "./Income.vue?vue&type=template&id=2e5035b4"
import script from "./Income.vue?vue&type=script&lang=js"
export * from "./Income.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matt/websites/code-practice.test/portfolio/expense-tracker/vuecli/expense-tracker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__